import styled from "styled-components";

export const PaginationContainer = styled.div`
    margin: 20px;
    display: flex;
    justify-content: flex-end;
`;
